import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield, Mail, Lock, LogIn, UserPlus, ArrowRight, Loader2 } from "lucide-react";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/format";

export default function Login() {
  const nav = useNavigate();
  const { login, register } = useAuth();
  const [mode, setMode] = useState("login");
  const [email, setEmail] = useState("admin@crafguard.com");
  const [password, setPassword] = useState("Admin@123");
  const [name, setName] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      if (mode === "login") {
        const u = await login(email, password);
        nav(u.role === "client" ? "/portal" : "/dashboard");
      } else {
        const u = await register({ email, password, name, role: "professional" });
        nav(u.role === "client" ? "/portal" : "/dashboard");
      }
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-brand-side">
        <div className="auth-brand-header">
          <div className="brand-mark"><Shield size={22} /></div>
          <div>
            <b>CRAF<span>GUARD</span></b>
            <small>GESTÃO OPERACIONAL</small>
          </div>
        </div>
        <div className="auth-brand-body">
          <span className="eyebrow">PLATAFORMA PARA CONSULTORES DE ARMAS</span>
          <h1>Sua carteira de clientes CAC, organizada num só painel.</h1>
          <p>Cadastre clientes, armas, processos e documentos. Acompanhe vencimentos de CRAF, guias de tráfego e transferências — com um portal dedicado para cada cliente.</p>
          <ul className="auth-feature-list">
            <li><i /> Agenda consolidada de vencimentos</li>
            <li><i /> Portal do cliente com documentos e status</li>
            <li><i /> Upload seguro de guias, CRAFs e certidões</li>
            <li><i /> Dados demonstrativos com 1 clique</li>
          </ul>
        </div>
        <div className="auth-brand-footer">© {new Date().getFullYear()} CRAFGuard Pro · Consultoria especializada em CAC</div>
      </div>

      <div className="auth-form-side">
        <div className="auth-card">
          <span className="eyebrow">{mode === "login" ? "ACESSAR CONTA" : "CRIAR CONTA"}</span>
          <h2>{mode === "login" ? "Bem-vindo de volta." : "Comece agora."}</h2>
          <p className="auth-sub">{mode === "login" ? "Entre com seu e-mail e senha." : "Crie sua conta profissional em segundos."}</p>

          <form onSubmit={submit} className="auth-form">
            {mode === "register" && (
              <label>
                <span>Nome completo</span>
                <div className="input"><input data-testid="register-name-input" required value={name} onChange={e=>setName(e.target.value)} placeholder="Ex.: Alessandro Silveira" /></div>
              </label>
            )}
            <label>
              <span>E-mail</span>
              <div className="input"><Mail size={15}/><input data-testid="login-email-input" type="email" required value={email} onChange={e=>setEmail(e.target.value)} placeholder="voce@empresa.com" /></div>
            </label>
            <label>
              <span>Senha</span>
              <div className="input"><Lock size={15}/><input data-testid="login-password-input" type="password" required value={password} onChange={e=>setPassword(e.target.value)} placeholder="••••••••" /></div>
            </label>
            {err && <div data-testid="login-error" className="auth-error">{err}</div>}
            <button data-testid="login-submit-button" type="submit" className="primary-button auth-submit" disabled={busy}>
              {busy ? <Loader2 size={16} className="spin"/> : (mode === "login" ? <LogIn size={16}/> : <UserPlus size={16}/>)}
              {mode === "login" ? "Entrar" : "Criar conta"}
              <ArrowRight size={14}/>
            </button>
          </form>

          <div className="auth-switch">
            {mode === "login" ? (
              <>Não tem conta? <button data-testid="switch-to-register" type="button" onClick={()=>setMode("register")}>Criar conta profissional</button></>
            ) : (
              <>Já tem conta? <button data-testid="switch-to-login" type="button" onClick={()=>setMode("login")}>Entrar</button></>
            )}
          </div>

          <div className="auth-hint">
            <b>Admin demo</b> · admin@crafguard.com · Admin@123
          </div>
        </div>
      </div>
    </div>
  );
}
